import { baseInput } from "./_base.js";
import { valid, invalid } from "./_state.js";
const textarea = {
  ...baseInput,
  "&[aria-invalid='true']": {
    ...invalid
  },
  "&[aria-invalid='false']": {
    ...valid
  }
};
export {
  textarea
};
//# sourceMappingURL=textarea.js.map
